module.exports = __webpack_public_path__ + "img/content_bg2@3x.88fc33e7.png";